/// <reference path="commondataservicebase.ts" />
/// <reference path="../models/meevo.model.custom.ts" />
module Meevo.Components.CommonClasses {
    /**
     * Represents a sub section within a common maintenance form.
     * @returns {}
     */
    export abstract class CommonSectionBase implements ICommonSection {
        loadingInProgress: boolean;
        model: any;
        baseEndpoint: string;
        sectionEndpoint: string;
        handlesOwnCrud: boolean;
        displayNameContentKey: string;
        isLoaded: boolean;
        isPrimarySection: boolean;
        isVisible: boolean;
        noun: Meevo.Model.NounEnum;

        sectionId: number;
        protected template: string;
        protected loadTimeStamp: Date;
        protected parentItemId: Guid;
        mode: Meevo.Model.MaintenanceFormState;
        protected loggingService: Meevo.Components.Logging.ILoggingService;
        protected dataService: Meevo.Components.CommonClasses.ICommonDataService;
        protected identityService: Meevo.Components.Common.IIdentityService;
        private backup: any;
        sectionSecurityKey: string;
        protected isInteropContext = false;

        constructor(
          sectionId: number,
          displayNameContentKey: string,
          template: string,
          isPrimarySection: boolean,
          handlesOwnCrud: boolean,
          baseEndpoint: string,
          sectionEndpoint: string,
          loggingService: Meevo.Components.Logging.ILoggingService,
          dataService: Meevo.Components.CommonClasses.ICommonDataService,
          noun: Meevo.Model.NounEnum = null,
          identityService: Components.Common.IIdentityService = null,
          sectionSecurityKey?: string
        ) {

            this.sectionId = sectionId;
            this.displayNameContentKey = displayNameContentKey;
            this.template = template;
            this.isPrimarySection = isPrimarySection;
            this.handlesOwnCrud = handlesOwnCrud;
            this.baseEndpoint = baseEndpoint;
            this.sectionEndpoint = sectionEndpoint;
            this.loggingService = loggingService;
            this.dataService = dataService;
            this.isVisible = true;

            this.loadingInProgress = false;
            this.isLoaded = false;
            this.mode = Meevo.Model.MaintenanceFormState.Readonly;
            this.noun = noun;
            this.identityService = identityService;
            this.sectionSecurityKey = sectionSecurityKey;
        }

        /**
         * Handles retrieval of the item from the data service (if it hasn't already been loaded)
         * @returns {}
         */
        public activate(): void {
            this.isLoaded = true;
        }

        /**
         * Creates a backup of the currently loaded model
         * @returns {}
         */
        takeBackup(): void {
            this.backup = angular.copy(this.model);
        }

        /**
         * Restores the original model values which were stored at the time of load.
         * @returns {}
         */
        rollbackChanges(): void {
            this.model = angular.copy(this.backup);
        }

        /**
         * Wrapper which assigns sub-class created model instance to the model.
         * @returns {}
         */
        createInstance(postAdd: (data: any) => any): void {
            this.createSectionModelInstance((data: any) => postAdd(data));
        }

        /**
         * Prepare model to save
         * */
        preSave(): any {
            return this.model;
        }

        selected(): void {
        }

        /**
         * Creates an instance of this section for use during an add.
         * @returns {T}
         */
        protected createSectionModelInstance(postAdd: (data: any) => any): void {
            throw (`In order for 'Add' / (createInstance) to work, a section needs to have
        createSectionModelInstance implemented in a subclass.`);
        }

        /**
         * If the section instance manages it's own state, this evaluates whether it is in 'Edit' mode.
         * @return {boolean}
         */
        get isEditing(): boolean {
            return this.handlesOwnCrud && this.mode === Meevo.Model.MaintenanceFormState.Editing;
        }

        /**
         * If the section instance manages it's own state, this evaluates whether it is in 'Readonly' mode.
         * @return {boolean}
         */
        get isReadonly(): boolean {
            return this.handlesOwnCrud && this.mode === Meevo.Model.MaintenanceFormState.Readonly;
        }

        get originalEntity(): any {
            return this.backup;
        }

        public canSaveLogic(): boolean {
            return true;
        }

        public sectionModelRetrieved(): void {

        }
    }
}
